import React from 'react';
import BodyLoading from '../../campaigns/modules/common-campaign-form/components/BodyLoading/BodyLoading';
import { SideDrawer } from './components/SideDrawer/SideDrawer';
import { useMultiLayerDrawer } from './hooks/useMultiLayerDrawer';
import styles from './multiLayerDrawer.module.scss';

export const MultiLayerDrawer = () => {
    const { isMultiLayerDrawerEnabled, drawerStack, pop, getDrawerData, getLayerStyle } = useMultiLayerDrawer();

    if (!isMultiLayerDrawerEnabled) {
        return null;
    }

    return (
        <>
            {drawerStack.map((_, index) => {
                const { path, Component, props, pattern, ModuleProvider } = getDrawerData(index);
                const layerStyle = getLayerStyle(index);

                return (
                    <SideDrawer
                        key={index}
                        pop={pop}
                        openDrawer={!!path}
                        index={index}
                        path={path}
                        layerStyle={layerStyle}
                    >
                        {Component ? (
                            ModuleProvider ? (
                                <ModuleProvider>
                                    <Component {...props} path={path} pattern={pattern} />
                                </ModuleProvider>
                            ) : (
                                <Component {...props} path={path} pattern={pattern} />
                            )
                        ) : (
                            <BodyLoading className={styles['loading']} />
                        )}
                    </SideDrawer>
                );
            })}
        </>
    );
};
